import { getUserManager } from './oidcClient';

export async function getValidAccessToken(): Promise<string | null> {
    if (typeof window === 'undefined') {
        return null;
    }

    const mgr = getUserManager();
    if (!mgr) return null;

    let user = await mgr.getUser();

    if (user) {
        if (user.expired) {
            try {
                user = await mgr.signinSilent();
            } catch (_e) {
                return null;
            }
        }
        return user?.id_token ?? null;
    }

    return null;
}
